import React, { Component } from 'react';
import { getTestByVersion } from '../common/task-utility';
import { isMobile, isIOS, isMobileSafari, isIOS13, isIPhone13, isIPad13 } from 'react-device-detect';
import {
	AssessmentContainer,
	AssessmentHeader,
	AssessmentNavigation,
	OnScreenKeyboard
} from '../common';

const createTask = (WrappedComponent, classNames) => {
	return class Task extends Component {
		constructor(props) {
			super(props);

			this.state = {
				containerClass: '',
				disableArrows: true
			};

			this.preloaded = false;
			this.task = {};
			this.headerText = '';
			this.handleKeydown = this.handleKeydown.bind(this);
			this.selectResponse = this.selectResponse.bind(this);
			this.handleBack = this.handleBack.bind(this);
			this.handleNext = this.handleNext.bind(this);
		}

		componentDidMount() {
			const { subTaskType, startTimer } = this.props;

			if (subTaskType.type === 'tasks') {
				startTimer();
			}

			this.delayArrows();
			this.preloadImages();
			this.preloaded = true;
			window.addEventListener('keydown', this.handleKeydown);
		}

		componentDidUpdate() {
			if (!this.preloaded) {
				this.preloadImages();
				this.preloaded = true;
			}

			this.delayArrows();
		}

		componentWillUnmount() {
			window.removeEventListener('keydown', this.handleKeydown);
		}

		handleKeydown(e, key = null) {
			if ((!!e && e.repeat) || (!e && !key)) {
				return;
			}

			const { save, data, pauseTimer, disableTimer, saveScreenDuration, setShowSavedPopup, logToSentry } = this.props;
			const { username, tests } = data.userData;
			const testIndex = tests.findIndex(test => test.versionNum === data.versionID);

			if ((key && key === 's') || (!!e && e.altKey && (e.code === 'KeyS' || e.which === 83))) {
				logToSentry('info', 'User Forced Save')
				setShowSavedPopup(true, () => {
					saveScreenDuration();
					save({
						username,
						testName: tests[testIndex].fullName,
						value: 0
					})
				});
			}

			if ((key && key === 't') || (!!e && e.altKey && (e.code === 'KeyT' || e.which === 84))) {
				logToSentry('info', 'User Disabled Timer')
				disableTimer();
			}

			if ((key && key === 'u') || (!!e && e.altKey && (e.code === 'KeyU' || e.which === 85))) {
				logToSentry('info', 'User invoked pause key')
				pauseTimer(() => {
					saveScreenDuration();
					save({
						username,
						testName: tests[testIndex].fullName,
						value: 0
					});
				});
			}
		}

		preloadImages() {
			const { tasks } = this.props;

			const preloadTasks = {
				currentTask: tasks[this.currentIndex],
				prevTask: this.isBackVisible() ? tasks[this.prevIndex] : null,
				nextTask: this.isNextVisible() ? tasks[this.nextIndex] : null,
			};

			Object.keys(preloadTasks).forEach(key => {
				if (!preloadTasks[key]) {
					return;
				}

				preloadTasks[key].mediaPath.forEach(url => {
					const img = new Image();
					img.src = url;
				});
			});
		}

		delayArrows() {
			if (this.state.disableArrows) {
				setTimeout(() => this.setState({disableArrows: false}), 500);
			}
		}

		setCurrentIndex() {
			let currentIndex = 0;
			const { index } = this.props.match.params;

			if (index !== undefined) {
				currentIndex = index - 1;
			}

			this.currentIndex = currentIndex;
			this.prevIndex = currentIndex - 1;
			this.nextIndex = currentIndex + 1;
		}

		setCurrentTask() {
			const { history, tasks, subTaskType, versionID } = this.props;
			const currentIndex = this.currentIndex;
			const task = tasks[currentIndex];
			const test = getTestByVersion(versionID);

			if (!task) {
				this.task = null;
				history.goBack();
				return;
			}

			if (test === 'Quant' || subTaskType.type === 'practice') {
				task.options.forEach((option, i) => {
					if (test === 'Quant') {
						task.options[i].text = ['A', 'B', 'C', 'D', 'E'][i];
					}

					if (subTaskType.type === 'practice') {
						task.options[i].isCorrect = option.value === task.requiredResponse;
					}
				});
			}

			this.task = task;
		}

		setHeaderText() {
			const currentIndex = this.currentIndex;
			this.headerText = this.props.subTaskType.type === 'practice' ? ['A', 'B', 'C'][currentIndex] : (currentIndex + 1);
		}

		selectResponse(response) {
			const { taskType, subTaskType, setTaskResponse } = this.props;
			setTaskResponse(this.task, taskType, subTaskType, response);

			if (subTaskType.type === 'practice') {
				this.setState(prevState => {
					if (!prevState.containerClass.includes('show-correct')) {
						return {containerClass: ' show-correct'};
					}
				});
			}
		}

		handleBack() {
			if (this.state.disableArrows) {
				return;
			}

			const { history, previousLink, saveScreenDuration } = this.props;
			this.setState({disableArrows: true});
			saveScreenDuration();
			this.preloaded = false;
			history.push(previousLink);
		}

		handleNext() {
			if (this.state.disableArrows) {
				return;
			}

			const { history, nextLink, subTaskType, saveScreenDuration } = this.props;
			const { response, requiredResponse } = this.task;
			this.task.isCorrect = response.includes(requiredResponse) ? 1 : 0;
			this.task.response = response.map(item => {
				item = item < 0 ? 0 : item;
				return item;
			});

			if (subTaskType.type === 'practice') {
				if (!this.task.isCorrect) {
					return;
				}

				this.setState({containerClass: ''});
			}

			this.setState({disableArrows: true});
			saveScreenDuration();
			this.preloaded = false;
			history.push(nextLink);
		}

		isBackVisible() {
			const { subTaskType, match } = this.props;

			if (subTaskType.type === 'practice' || match.params.index <= 1) {
				return false;
			}

			return true;
		}

		isNextVisible() {
			return true;
		}

		isIpadOS() {
			return (('ontouchstart' in window) || (navigator.maxTouchPoints > 0)) && (/Macintosh/).test(navigator.userAgent);
		}

		render() {
			this.setCurrentIndex();
			this.setCurrentTask();
			this.setHeaderText();

			if (!this.task) {
				return;
			}

			return (
				<AssessmentContainer className={classNames.container + this.state.containerClass}>
					{(isMobile || isIOS || isMobileSafari || isIOS13 || isIPhone13 || isIPad13 || this.isIpadOS()) && this.props.subTaskType.type === 'tasks' ? <OnScreenKeyboard handleKeydown={this.handleKeydown} /> : ''}
					<AssessmentHeader className={classNames.header}>{this.headerText}</AssessmentHeader>
					<WrappedComponent task={this.task} {...this.props} selectResponse={this.selectResponse} />
					<AssessmentNavigation className={classNames.navigation} type="back" onClick={this.handleBack} isVisible={this.isBackVisible()} />
					<AssessmentNavigation className={classNames.navigation} type="next" onClick={this.handleNext} isVisible={this.isNextVisible()} />
				</AssessmentContainer>
			);
		}
	}
}

export default createTask;